// extracted by mini-css-extract-plugin
var _1 = "AboutSettings_button__-aAv3";
var _2 = "AboutSettings_demoMode__LeJlf";
var _3 = "AboutSettings_donateButton__LnJYd";
var _4 = "AboutSettings_icon__g2FyU";
var _5 = "AboutSettings_link__Nw7b4";
var _6 = "AboutSettings_links__d6vT1";
var _7 = "AboutSettings_logo__Wmzni";
var _8 = "AboutSettings_version__wQEb5";
export { _1 as "button", _2 as "demoMode", _3 as "donateButton", _4 as "icon", _5 as "link", _6 as "links", _7 as "logo", _8 as "version" }
